import { render } from "./delDialog.vue?vue&type=template&id=4ed77635&scoped=true"
import script from "./delDialog.vue?vue&type=script&lang=js"
export * from "./delDialog.vue?vue&type=script&lang=js"

import "./delDialog.vue?vue&type=style&index=0&id=4ed77635&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed77635"]])

export default __exports__